// The legacy storybook registers components under the same aha-* names globally, and Vue resolves a
// registered component before an ignored element. An own key set to undefined makes Vue render the
// design system custom element instead.
const AHA_ELEMENT_TAGS = [
  'aha-alert',
  'aha-button',
  'aha-icon',
  'aha-input',
  'aha-list',
  'aha-segmented',
  'aha-select',
  'aha-status-badge',
  'aha-switch',
  'aha-tag',
  'aha-tabs',
]

export default Object.fromEntries(AHA_ELEMENT_TAGS.map(tag => [tag, undefined]))
